import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import Snow from "src/components/Snow/Snow"
import SessionProvider from './hoc/SessionProvider/SessionProvider'
import { YMInitializer } from 'react-yandex-metrika'

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
)

const queryClient = new QueryClient()

root.render(
    // <React.StrictMode>
    <QueryClientProvider client={queryClient}>
        <YMInitializer accounts={[99238949]} options={{ webvisor: true }}/>
        <Snow/>
        <SessionProvider>
            <App/>
        </SessionProvider>
    </QueryClientProvider>
    // </React.StrictMode>
)